const TitleTypes = {
  Tab: "tab",
  Widget: "widget"
};
export default TitleTypes;
